import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../../../hooks/customDocumentTitleHook";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeDate, getPractice, usPhoneFormat } from "../../../../helpers";
import { fetchSingleImmunizationForm } from "../../../../services/forms";

export default function ImmunizationPrint({ ...props }) {
  const {    
    formViewId,
    formViewSize = "A4",
    setFormView = () => {}
  } = props;

  const [formData, setFormData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const navigate = useNavigate();
  const contentRef = useRef();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const accountId = getPractice("account_id");
  const locationId = getPractice("location_id");

  let formId = formViewId;
  let formSize = formViewSize;
  if (queryParams.get('form_id')) {
    formId = queryParams.get('form_id');
    formSize = queryParams.get('size');
  } 

  useEffect(() => {
    if(formId !== null){
      getReferralData( formId );
    } else {
      navigate(-1);
    }
  }, [formId]);

  const getReferralData = async ( formId ) => {
    const response = await fetchSingleImmunizationForm( accountId, locationId, formId );
    if (response) {
      if(response.data === null) {
        window.close();
      }
      setFormData(response?.data);
      setIsDataLoaded(true);
    }
  };

  const handlePrint = () => {
    window.print();
  };

  useEffect(() => {
    if (isDataLoaded && queryParams.get('form_id')) {
      handlePrint();
    }
  }, [isDataLoaded, queryParams]);

  const handleCloseWindow = () => {
    window.close();
  };

  const handleFormPrint = (formId) => {
    setFormView();
    const url = `/forms/immunization-form/print?form_id=${formId}&size=A4`;
    window.open(url, '_blank');
  };

  useEffect(() => {
    const pageSize = formSize == "A4" ? "A4" : "Letter";
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      @media print {
        @page {
          size: ${pageSize};
        }
      }
    `;
    document.head.appendChild(styleElement);
    return () => {
      document.head.removeChild(styleElement);
    };
  }, [formSize]);

  useDocumentTitle("Immunization Form");

  return (
    <div ref={contentRef} className="docpro_signout_wrap">
      <div className="docpro_signout">
        <div>
          <h4 className="text-center pb-2 docpro_fs_26"><u>Influenza/Pneumococcal Immunization Consent Form</u></h4>

          <div className="docpro_table_1 hipaa_table mt-4 docpro_table_responsive" style={{ boxShadow: 'none', borderRadius: 0, paddingBottom: 0, overflowX: 'auto' }}>
            <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)', borderTop: 'none' }} className="p-2">
                    <p className="mb-0"><strong>Name:</strong><br /> {formData?.last_name} {formData?.first_name}</p>
                  </td>
                  <td style={{ borderRight: '1px solid var(--border)', borderTop: 'none' }} className="p-2">
                    <p className="mb-0"><strong>Date of Birth:</strong><br /> {exchangeDate(formData?.birth)}</p>
                  </td>
                  <td style={{ borderRight: '1px solid var(--border)', borderTop: 'none' }} className="p-2">
                    <p className="mb-0"><strong>Sex:</strong><br /> {formData?.gender == 1 ? 'Male' : formData?.gender == 2 ? 'Female' : "Other"}</p>
                  </td>
                  <td style={{ borderTop: 'none' }} className="p-2">
                    <p className="mb-0"><strong>County of Residence:</strong><br /> {formData?.res_country}</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0" style={{ minHeight: '60px' }}><strong>Address:</strong><br /> {formData?.address}</p>
                  </td>
                  <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0"><strong>City:</strong><br /> {formData?.city}</p>
                  </td>
                  <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0"><strong>State:</strong><br /> {formData?.state}</p>
                  </td>
                  <td className="p-2">
                    <p className="mb-0"><strong>ZIP:</strong><br /> {formData?.zip}</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0"><strong>Phone:</strong><br /> {usPhoneFormat(formData?.phone)}</p>
                  </td>
                  <td colSpan={3} className="p-2">
                    <p className="mb-0"><strong>For Persons Under 19 Years Old, Mother’s Maiden Name:</strong><br />{formData?.maiden_name}</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0"><strong>Medicare Claim Number:</strong><br /> {formData?.claim_number}</p>
                  </td>
                  <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0"><strong>Doctor’s Name:</strong><br /> {formData?.dr_name}</p>
                  </td>
                  <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0"><strong>Medicare Claim Number:</strong><br /> {formData?.ins_provider}</p>
                  </td>
                  <td className="p-2">
                    <p className="mb-0"><strong>Doctor’s Name:</strong><br /> {formData?.dr_address}</p>
                  </td>
                </tr>
                <tr>
                  <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0" style={{ minHeight: '60px' }}><strong>Policy Number:</strong><br /> {formData?.policy_no}</p>
                  </td>
                  <td colSpan={2} style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                    <p className="mb-0"><strong>Clinic/Office Site Where Vaccine Administered:</strong><br /> {formData?.office_site}</p>
                  </td>
                  <td className="p-2">
                    <p className="mb-0"><strong>NYSIIS Permission ≥ 19 Years Old:</strong><br />
                    <span className="flex items-center">
                      <input className="form-check-input mr-2" type="checkbox" checked={formData?.nysiis == 1} disabled />
                      <span className="mr-2">Yes</span>
                      <input className="form-check-input mr-2 pl-2" type="checkbox" checked={formData?.nysiis == 0} disabled />
                      <span>No</span>
                    </span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-4 border_div page-2">
            <p className="pb-1">Please complete the questions below for yourself or the person receiving the vaccine.</p>

            <div className="docpro_table_1 hipaa_table mt-4 docpro_table_responsive" style={{ boxShadow: 'none', borderRadius: 0, paddingBottom: 0, overflowX: 'auto' }}>
              <table className="docpro_mb_0 docpro_primary_color" style={{ width: '100%' }}>
                <tbody>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)', borderTop: 'none' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.fever == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.fever == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td style={{ borderTop: 'none' }} className="p-2">
                      <p className="mb-0">Are you currently sick with a fever?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.allergy == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.allergy == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Have you ever had a life threatening allergy to any component (or part) of the flu or pneumonia vaccine? <br/> 
                      If yes, please describe:<span className="input-text">{formData?.allergy_yes}</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.guillain == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.guillain == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Have you ever developed Guillain-Barre Syndrome within 6 weeks of receiving flu vaccine?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.pneumonia == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.pneumonia == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Have you ever had a pneumonia shot?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.asthma == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.asthma == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Are you a smoker or have a chronic medical condition such as asthma, heart or lung disease? <br/>
                      If yes, please describe:<span className="input-text">{formData?.asthma_yes}</span></p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.allergy_eat == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.allergy_eat == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Have you ever had a severe life threatening allergy to eggs or egg products?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.pregnant == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.pregnant == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Are you currently pregnant?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.wheezing == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.wheezing == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Do you have a history of asthma or wheezing?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.aspirin == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.aspirin == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Are you a child or adolescent receiving long-term aspirin therapy?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.special_care == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.special_care == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Do you have a weakened immune system or have close contact with a person with an extremely weakened immune system who needs special care?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.vaccination == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.vaccination == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Have you received any other vaccinations within the last 4 weeks?</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={{ borderRight: '1px solid var(--border)' }} className="p-2">
                      <div className="flex items-center">
                        <input className="form-check-input" type="checkbox" checked={formData?.antiviral == 1} disabled />
                        <span className="pr-2 mr-2">YES</span>
                        <input className="form-check-input" type="checkbox" checked={formData?.antiviral == 2} disabled />
                        <span>NO</span>
                      </div>
                    </td>
                    <td className="p-2">
                      <p className="mb-0">Have you taken an antiviral medication for the flu within the last 48 hours?</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {formSize == 'A4' ?
            <div className="spacing_1"></div>
          :
            <div className="spacing_9"></div>
          }

          <div className="docpro_grid docpro_grid_gap_4 docpro_grid_col_2 mt-4" style={{ borderTop: '2px solid var(--border)' }}>
            <div className="mb-2 docpro_grid_item immunization_flex">
              <div>
                <h5 className="fw-bold mt-2">Influenza Consent</h5>
                <p>
                  I have read, or had explained to me, the Vaccine Information Statement about <b>influenza</b> vaccination. I have had a chance to ask questions, which were answered to my satisfaction, and I understand the benefits and risks of the vaccination as described. I request that the <b>influenza</b> vaccination be given to me (or the person named above for whom I am authorized to make this request). I authorize the release of any medical or other information necessary to process a Medicare or other insurance claim or for other public health purpose. I have received a copy of the Patient Bill of Rights.
                </p>
                <div className="flex">
                  <div style={{ width: '70%' }}>
                    <div className="rounded p-1" style={{ height: "80px", width: "160px" }}>
                      {formData?.recipient_1_signature !== null &&
                        <img src={`${formData?.recipient_1_signature}`} className="img-fluid d-block img_print" alt="signature" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                      }
                    </div>
                    <hr />
                    Signature of Recipient (Parent or Guardian)
                  </div>
                  <div style={{ width: '30%', alignItems: 'end', justifyContent: 'center' }} className="flex">
                    <div className="text-center">
                      <p className="mb-0 text-center">{exchangeDate(formData?.sign1_date)}</p>
                      <hr />
                      Date
                    </div>
                  </div>
                </div>
              </div>
              <div className="border_div">
              </div>
            </div>
            <div className="mb-2 docpro_grid_item">
              <h5 className="fw-bold mt-2">Pneumococcal Consent</h5>
              <p>
                I have read, or had explained to me, the Vaccine Information Statement about <b>pneumococcal</b> vaccination. I have had a chance to ask questions, which were answered to my satisfaction, and I understand the benefits and risks of the vaccination as described. I request that the <b>pneumococcal</b> vaccination be given to me (or the person named above for whom I am authorized to make this request). I authorize the release of any medical or other information necessary to process a Medicare or other insurance claim or for other public health purpose. I have received a copy of the Patient Bill of Rights.
              </p>
              <div className="flex">
                <div style={{ width: '70%' }}>
                  <div className="rounded p-1" style={{ height: "80px", width: "160px" }}>
                    {formData?.recipient_2_signature !== null &&
                      <img src={`${formData?.recipient_2_signature}`} className="img-fluid d-block img_print" alt="signature" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    }
                  </div>
                  <hr />
                  Signature of Recipient (Parent or Guardian)
                </div>
                <div style={{ width: '30%', alignItems: 'end', justifyContent: 'center' }} className="flex">
                  <div className="text-center">
                    <p className="mb-0 text-center">{exchangeDate(formData?.sign2_date)}</p>
                    <hr />
                    Date
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-light nurse-background" style={{ backgroundColor: '#a8a9ad' }}>
            <h5 className="text-center mb-0 py-1 fw-bold text-white">Area Below to Be Completed by Nurse</h5>
          </div>

          <div className="docpro_grid docpro_grid_gap_4 docpro_grid_col_2">
            <div className="mb-2 docpro_grid_item immunization_flex">
              <div>
                <h5 className="fw-bold mt-4">Influenza Vaccine</h5>
                <div className="flex mb-2"><p className="mb-0 pe-3" style={{ minWidth: 130 }}>Administration Date</p><span className="mx-1">:</span><span className="input-text"></span></div>
                <div className="flex mb-2">
                  <p className="mb-0 pe-3" style={{ minWidth: 130 }}>Administration Site</p><span className="mx-1">:</span>
                  <div className="flex items-center" style={{ flexWrap: 'wrap' }}>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span className="pr-2 mr-2">Left Arm</span>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span className="pr-2 mr-2">Right Arm</span>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span className="pr-2 mr-2">Nasal</span>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span className="pr-2 mr-2">Left Thigh</span>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span>Right Thigh</span>
                  </div>
                </div>
                <div className="flex mb-2">
                  <p className="mb-0 pe-3" style={{ minWidth: 130 }}>Dosage</p><span className="mx-1">:</span>
                  <div className="flex items-center" style={{ flexWrap: 'wrap' }}>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span className="pr-2 mr-2">0.5 ml</span>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span className="pr-2 mr-2">0.25 ml</span>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span>LAIV</span>
                  </div>
                </div>
                <div className="flex mb-2"><p className="mb-0 pe-3" style={{ minWidth: 130 }}>Manufacturer & Lot Number</p><span className="mx-1">:</span><span className="input-text"></span></div>
                <div className="flex mb-2"><p className="mb-0 pe-3" style={{ minWidth: 130 }}>VIS Date</p><span className="mx-1">:</span><span className="input-text"></span></div>
                <div className="flex mb-2">
                  <p className="mb-0 pe-3" style={{ minWidth: 130 }}>Nurse Signature</p><span className="mx-1">:</span>
                  <div className="rounded p-1" style={{ height: "80px", width: "160px" }}></div>
                </div>
                <div className="flex mb-1">
                  <p className="mb-0 pe-3" style={{ minWidth: 140, whiteSpace: 'nowrap' }}>Next Immunization Due</p><span className="mx-1">:</span>
                  <div>
                    <div className="flex items-center mb-1" style={{ flexWrap: 'wrap' }}>
                      <input className="form-check-input" type="checkbox" disabled />
                      <span className="pr-2 mr-2">Next Year</span>
                      <input className="form-check-input" type="checkbox" disabled />
                      <span className="pr-2 mr-2">In 4 Weeks</span>
                    </div>
                    <div className="flex items-center" style={{ flexWrap: 'wrap', marginLeft: '-28px' }}>
                      <input className="form-check-input" type="checkbox" disabled />
                      <span className="mr-2">Other  <span className="input-text"></span></span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border_div">
              </div>
            </div>

            <div className="mb-2 docpro_grid_item">
              <h5 className="fw-bold mt-4">Pneumococcal Disease Vaccine</h5>
              <div className="flex mb-2"><p className="mb-0 pe-3" style={{ minWidth: 130 }}>Administration Date</p><span className="mx-1">:</span><span className="input-text"></span></div>
              <div className="flex mb-2">
                <p className="mb-0 pe-3" style={{ minWidth: 130 }}>Administration Site</p><span className="mx-1">:</span>
                <div className="flex items-center" style={{ flexWrap: 'wrap' }}>
                  <input className="form-check-input" type="checkbox" disabled />
                  <span className="pr-2 mr-2">Left Arm</span>
                  <input className="form-check-input" type="checkbox" disabled />
                  <span className="pr-2 mr-2">Right Arm</span>
                  <input className="form-check-input" type="checkbox" disabled />
                  <span className="pr-2 mr-2">Left Thigh</span>
                  <input className="form-check-input" type="checkbox" disabled />
                  <span>Right Thigh</span>
                </div>
              </div>
              <div className="flex mb-2"><p className="mb-0 pe-3" style={{ minWidth: 130 }}>Manufacturer & Lot Number</p><span className="mx-1">:</span><span className="input-text"></span></div>
              <div className="flex mb-2"><p className="mb-0 pe-3" style={{ minWidth: 130 }}>VIS Date</p><span className="mx-1">:</span><span className="input-text"></span></div>
              <div className="flex mb-2">
                <p className="mb-0 pe-3" style={{ minWidth: 130 }}>Nurse Signature</p><span className="mx-1">:</span>
                <div className="rounded p-1" style={{ height: "80px", width: "160px" }}></div>
              </div>
              <div className="flex mb-1">
                <p className="mb-0 pe-3" style={{ minWidth: 130, whiteSpace: 'nowrap' }}>Next Immunization Due</p><span className="mx-1">:</span>
                <div>
                  <div className="flex items-center mb-1" style={{ flexWrap: 'wrap' }}>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span className="pr-2 mr-2">None Needed</span> 
                  </div>
                  <div className="flex items-center" style={{ flexWrap: 'wrap', marginLeft: '-28px' }}>
                    <input className="form-check-input" type="checkbox" disabled />
                    <span className="mr-2">Other <span className="input-text"></span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p className="mt-2">DOH-4156 (6/14)</p>
        </div >
      </div>

      <div className="docpro_invoice_btns docpro_hide_print">
        <button
          className="docpro_invoice_btn docpro_color3 close_button"
          onClick={() => {
            if (queryParams.get('form_id')) {
              handleCloseWindow();
            } else {
              setFormView();
            }
          }}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
          </span>
          <span className="docpro_btn_text">Close</span>
        </button>

        <button
          className="docpro_invoice_btn docpro_color1"
          onClick={() => {
            if (queryParams.get('form_id')) {
              handlePrint();
            } else {
              handleFormPrint(formViewId);
            }
          }}
        >
          <span className="docpro_btn_icon">
            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon" viewBox="0 0 512 512" >
              <path d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} />
              <rect x={128} y={240} width={256} height={208} rx="24.32" ry="24.32" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <path d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24" fill="none" stroke="currentColor" strokeLinejoin="round" strokeWidth={32} /> 
              <circle cx={392} cy={184} r={24} fill="currentColor" /> 
            </svg>
          </span>
          <span className="docpro_btn_text">Print</span>
        </button>
      </div>
    </div>
  );
}
